module.exports = "<div class=\"p-l-50 m-l-20 p-r-50 m-r-20 p-t-50 m-t-30 sm-p-l-15 sm-p-r-15 sm-p-t-40\">\n    <div class=\"text-center\">\n        <img src=\"assets/img/logo.png\" alt=\"Logo\" data-src=\"assets/img/logo.png\" data-src-retina=\"assets/img/logo.png\" width=\"80%\">\n    </div>\n    <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/authentication/pages/partials/page-wrapper/page-wrapper.component.html
// module id = ./libs/chassis-core/src/app/authentication/pages/partials/page-wrapper/page-wrapper.component.html
// module chunks = main